import styled from '@emotion/styled';
import { fromTheme } from '@kyruus/ui-theme';
import { LIST_VIEW_MODE } from 'Common/config';

export const ProviderCardWrapper = styled.div`
  container-name: provider-card;
  container-type: inline-size;
`;

export const ProviderCardListContainer = styled.div`
  container-name: provider-card-list;
  container-type: inline-size;
`;

export const ProviderCardList = styled.div<{
  mode: 'list' | 'grid' | 'modern-grid';
}>`
  margin-bottom: ${fromTheme('spacing_xlarge')};

  ${(props) => {
    if (props.mode === LIST_VIEW_MODE.LIST) {
      return `
        display: flex;
        flex-direction: column;
        row-gap: ${fromTheme('spacing_medium')(props)};
      `;
    }

    if (props.mode === LIST_VIEW_MODE.MODERN_GRID) {
      return `
        --grid-layout-gap: ${fromTheme('spacing_large')(props)};
        --grid-column-count: ${fromTheme('provider_tile_list_column_count')(props) ?? 3};
        --grid-item--min-width: ${fromTheme('provider_tile_min_card_width')(props)};
        --gap-count: calc(var(--grid-column-count) - 1);
        --total-gap-width: calc(var(--gap-count) * var(--grid-layout-gap));
        --grid-item--max-width: calc(
          (100% - var(--total-gap-width)) / var(--grid-column-count)
        );
        display: grid;
        grid-template-columns: repeat(
          auto-fill,
          minmax(
            max(min(var(--grid-item--min-width), 100%), var(--grid-item--max-width)),
            1fr
          )
        );
        grid-gap: var(--grid-layout-gap);

        > div > div {
          height: 100%;
          > div {
            height: 100%;
          } 
        }
        
        & .ProviderCard--ctas:has(> div:empty) {
          display: none;
        }
        & .ProviderCard--badge .MuiChip-label.MuiChip-labelSmall {
          color: inherit !important;
        }
      `;
    }

    const minGridCardSize = '425px';
    return `
      display: flex;
      flex-direction: column;
      row-gap: ${fromTheme('spacing_medium')(props)};

      @container provider-card-list (width >= ${minGridCardSize}) {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(${minGridCardSize}, 1fr));
        gap: ${fromTheme('spacing_medium')(props)};
        align-items: stretch;

        .provider-card {
          height: 100%;
          
          > div {
            height: 100%;
            grid-template-rows: auto;
          }
        }

        @container provider-card (width < 600px) {
          .booking-actions,
          .booking-availability-tiles,
          .provider-card-locations {
            align-content: end;
          }
        }
      }
    `;
  }}
`;
